module.exports = __webpack_public_path__ + "img/安全保障.0226073e.png";